import { WebSiteUsersService } from './../../../providers/webSiteUsers/webSiteUsers.service';
import { Component, OnInit, Input, ContentChildren, QueryList, ViewChild, ElementRef, TemplateRef, AfterViewInit, ChangeDetectorRef, Output, EventEmitter, HostBinding } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { MenuService } from './../../../providers/menu/menu.service';
import { Subject, Observable } from 'rxjs';
@Component({
  selector: 'panel',
  inputs: ['id', 'label', 'active'],
  template: `<ng-content></ng-content>`
})
export class PanelComponent {
  @Input() id: string;
  @Input() label: string;
  @Input() @ViewChild(TemplateRef) label2: TemplateRef<any>;
  @Input() icon: string;
  @Input() active: boolean;
  @Input() disabled: boolean;
  @Input() step: boolean;
  @Input() @ViewChild(TemplateRef) content: TemplateRef<any>;
}

@Component({
  selector: 'panel-switch',
  templateUrl: './panel-switch.html'
})
export class PanelSwitchComponent implements AfterViewInit, OnInit {
  @Output() bounce: EventEmitter<any> = new EventEmitter<any>()
  constructor(private cdRef: ChangeDetectorRef) { }
  totalPanel: number;
  activePanel: number;
  private label;
  @Input() counterActive
  @Input() steps = false
  @Input() autoHeight = true
  @Input() theme
  @Output() onEnableAddButton: EventEmitter<any> = new EventEmitter<any>()
  @HostBinding('class.steps') get isSteps() {
    return this.steps;
  }
  @Input() goToNext: Observable<number> = new Observable<number>();
  @ContentChildren(PanelComponent) panelsRefs: QueryList<PanelComponent>

  ngAfterViewInit(): void {
    this.panels = this.panelsRefs.toArray();
    this.totalPanel = this.panels.length;
    if (this.panels) {
      let pane = this.panels[0]
      if (pane) {
        this.activePanel = 0;
        this.activateTab(pane)
      }
    }
    this.cdRef.detectChanges();
  }
  ngOnInit() {
    if (this.goToNext instanceof Subject) {
      this.goToNext.subscribe(
        (next) => {
          this.next();
        }
      )
    }
    setTimeout(() => {
      this.label = this.panels[this.activePanel].label;
    }, 100)
  }
  panels: PanelComponent[]
  @ViewChild('tabs') tabs: ElementRef;

  activateTab(panel: PanelComponent) {
    if (panel.active) {
      return
    }
    this.bounceFunction();
    panel.active = true;
    this.panels.forEach((p, index) => {
      if (p.id !== panel.id) {
        p.active = false
      } else {
        this.activePanel = index;
      }
    })
    if (this.activePanel == this.totalPanel - 1) {
      this.onEnableAddButton.emit(true);
    } else {
      this.onEnableAddButton.emit(false);
    }
    this.label = this.panels[this.activePanel].label;
  }
  next() {
    if (this.activePanel < this.totalPanel) {
      this.activePanel++;
      this.activateTab(this.panels[this.activePanel]);
      this.label = this.panels[this.activePanel].label;
    }
  }
  bounceFunction() {
    this.bounce.emit(true);
  }
}


// WEBPACK FOOTER //
// ./src/components/shared/panel-switch/panel-switch.ts